import React, { useEffect, useRef, useState } from "react";
import { showErrorToast } from "../../assets/toastUtils";
import "./FilterSection.css";
import styles from "./NewFilterHoliday.module.scss";
import { FilterIcon } from "../../utils/svgIcons";

function NewFilterHoliday({ sendDataToParent, showDestinations }) {
  const handleReset = () => {
    setDestinationArray([]);
    setSelectedBudget("");
    setDurationArray([]);
    setMinMax({ min: "", max: "" });
    setNoOfNights(0);
    setSelectedThemesArray([]);
  };

  const [mobileIsOpenDuration, setMobileIsOpenDuration] = useState(true);
  const [mobileIsOpenTheme, setMobileIsOpenTheme] = useState(true);

  const [isOpenBudget, setIsOpenBudget] = useState(true);
  const [isOpenCategory, setIsOpenCategory] = useState(true);
  const [isOpenDestination, setIsOpenDestination] = useState(true);
  const [themeOpen, setThemeOpen] = useState(false);
  const [isOpenThemes, setIsOpenThemes] = useState(false);
  const [noOfNights, setNoOfNights] = useState("");
  const [isOpenDuration, setIsOpenDuration] = useState(false);
  const [themesArray, setThemesArray] = useState([]);
  const [selectedThemesArray, setSelectedThemesArray] = useState([]);

  const fetchThemesDetails = () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/themes/list`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setThemesArray(data?.data);
        } else {
        }
      })
      .catch((error) => {
        console.error("Error fetching  details:", error);
      });
  };

  useEffect(() => {
    fetchThemesDetails();
  }, []);

  const toggleAccordionBudget = () => {
    setIsOpenBudget(!isOpenBudget);
  };
  const toggleAccordionCategory = () => {
    setIsOpenCategory(!isOpenCategory);
  };
  const toggleAccordionDestination = () => {
    setIsOpenDestination(!isOpenDestination);
  };
  const toggleTheme = () => {
    setThemeOpen(!themeOpen);
  };
  const toggleAccordionThemes = () => {
    setIsOpenThemes(!isOpenThemes);
  };

  const toggleAccordionDuration = () => {
    setIsOpenDuration(!isOpenDuration);
  };

  const handleCheckboxChange = () => {};
  // sam work start

  const [destinationArray, setDestinationArray] = useState([]);
  const [selectedBudget, setSelectedBudget] = useState("");
  const [durationArray, setDurationArray] = useState([]);
  const [minMax, setMinMax] = useState({
    min: "",
    max: "",
  });

  const handleBudgetChange = (value) => {
    setMinMax((prevMinMax) => ({
      min: "",
      max: "",
    }));
    setSelectedBudget(value);
  };

  const handleDurationCheckboxChange = (category) => {
    setNoOfNights("");
    setDurationArray((prevArray) => {
      if (prevArray.includes(category)) {
        return prevArray.filter((item) => item !== category);
      } else {
        return [...prevArray, category];
      }
    });
  };
  const handleDestinationHandleChange = (category) => {
    setDestinationArray((prevArray) => {
      if (prevArray.includes(category)) {
        return prevArray.filter((item) => item !== category);
      } else {
        return [...prevArray, category];
      }
    });
  };

  const handleThemesHandleChange = (category) => {
    setSelectedThemesArray((prevArray) => {
      if (prevArray.includes(category)) {
        return prevArray.filter((item) => item !== category);
      } else {
        return [...prevArray, category];
      }
    });
  };

  // console.log(destinationArray, "destinationArray");

  useEffect(() => {
    const data = {
      budget: selectedBudget,
      duration: durationArray,
      destinations: destinationArray,
      noOfNights: noOfNights,
      themes: selectedThemesArray,
    };

    sendDataToParent(data);
  }, [
    selectedBudget,
    durationArray,
    destinationArray,
    noOfNights,
    selectedThemesArray,
  ]);

  const handleBudgetChangeMinMax = (value) => {
    // console.log(value, "value");
    const { min, max } = value;
    if (Number(min) > Number(max)) {
      showErrorToast("Please Enter Valid Budget Range");
      return;
    }
    setSelectedBudget(`${min}-${max}`);
  };

  const onValuesChange = (data) => {
    setDurationArray([]);
    setNoOfNights(data);
  };

  const [modifyPkg, setModiyPkg] = useState(false);
  const [mobileHead, setMobileHead] = useState(true);
  const toggleModify = () => {
    setModiyPkg(!modifyPkg);
  };

  const closePopup = () => {
    setModiyPkg(false);
  };

  const sendingData = {
    budget: selectedBudget,
    themes: selectedThemesArray,
    duration: durationArray,
    destinations: destinationArray,
    noOfNights: noOfNights,
  };

  const overlayRef = useRef(null);

  const handleClickOutsideClosePopup = (e) => {
    if (
      window.innerWidth > 768 &&
      overlayRef.current &&
      !overlayRef.current.contains(e.target)
    ) {
      setIsOpenDestination(false);
      setIsOpenDuration(false);
      setThemeOpen(false);
    }

    if (window.innerWidth < 768) {
      setIsOpenBudget(true);
      setIsOpenDestination(true);
      setIsOpenDuration(true);
      setIsOpenThemes(true);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideClosePopup);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideClosePopup);
    };
  }, []);

  return (
    <>
      <div ref={overlayRef} className={styles.filters_mobile_wrapper}>
        <div className={styles.filters_mobile_parent}>
          <button onClick={toggleModify}>
            <FilterIcon />
            Filters
          </button>
        </div>
        {modifyPkg && (
          <div className="filters p_0" id="mobileFilters">
            <div className="p_20">
              <svg
                onClick={closePopup}
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1 12.5L13 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
                <path d="M13 12.5L1 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
              </svg>
            </div>
            <div className="agent border-bottom-one">
              <h4>Filter</h4>
              <div className="buttons m_0">
                <button
                  className="primary_btn"
                  onClick={handleReset}
                  style={{ width: "50px", backgroundColor: "#016937" }}
                >
                  Reset
                </button>
              </div>
            </div>
            {/* <div className="filter_checkbox border-bottom-one">
                <h6
                  className="flex_align_center justify_content_between"
                  onClick={toggleAccordionBudget}
                  style={{ cursor: "pointer" }}
                >
                  <b>
                    Budget <small>(Rate/Night)</small>
                  </b>
                  <svg
                    width="10"
                    height="8"
                    viewBox="0 0 13 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transition: "transform 0.5s",
                      transform: isOpenBudget
                        ? "rotate(0deg)"
                        : "rotate(180deg)",
                    }}
                  >
                    <path
                      d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                      stroke="#222222"
                      strokeWidth="1.5"
                    />
                  </svg>
                </h6>
                {isOpenBudget && (
                  <div>
                    <div className="flex pt_10">
                      <input
                        type="radio"
                        checked={"0-8000" === selectedBudget}
                        value={"0-8000"}
                        onChange={(e) => handleBudgetChange(e.target.value)}
                        id="0-8000"
                      />
                      <label htmlFor="0-8000">0 to ₹8,000</label>
                    </div>
                    <div className="flex pt_10">
                      <input
                        type="radio"
                        value={"8000-20000"}
                        checked={"8000-20000" === selectedBudget}
                        onChange={(e) => handleBudgetChange(e.target.value)}
                        id="8000-20000"
                      />
                      <label htmlFor="8000-20000">₹8,000 to ₹20,000</label>
                    </div>
                    <div className="flex pt_10">
                      <input
                        type="radio"
                        value={"20000-35000"}
                        checked={"20000-35000" === selectedBudget}
                        onChange={(e) => handleBudgetChange(e.target.value)}
                        id="20000-35000"
                      />
                      <label htmlFor="20000-35000">₹20,000 to ₹35,000</label>
                    </div>
                    <div className="flex pt_10">
                      <input
                        type="radio"
                        value={"35000-50000"}
                        checked={"35000-50000" === selectedBudget}
                        onChange={(e) => handleBudgetChange(e.target.value)}
                        id="35000-50000"
                      />
                      <label htmlFor="35000-50000">₹35,000 to 50,000</label>
                    </div>
                    
                  </div>
                )}
              </div> */}

            {/* Budget Filter */}
            {/* <div className="filter_checkbox border-bottom-one">
                <h6
                  className="flex_align_center justify_content_between"
                  onClick={toggleAccordionBudget}
                  style={{ cursor: "pointer" }}
                >
                  <b>No Of Nights</b>
                </h6>
                {isOpenBudget && (
                  <div
                    className="filter_range_parent"
                    style={{ padding: "10px 0", gap: "10px" }}
                  >
                    <input
                      style={{ width: "100%" }}
                      type="range"
                      min="0"
                      max="15"
                      // value={noOfNights}
                      onMouseUp={(e) => onValuesChange(e.target.value)}
                    // onChange={(e) => onValuesChange(e.target.value)}
                    // style={{ width: "100%" }}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "-10px",
                      }}
                    >
                      <span>0</span>
                      <span>15</span>
                    </div>
                  </div>
                )}
              </div> */}

            {/* Duration Filter */}
            <div className="filter_checkbox border-bottom-one">
              <h6
                className="flex_align_center justify_content_between"
                // onClick={toggleAccordionDuration}
                onClick={() => setMobileIsOpenDuration(!mobileIsOpenDuration)}
                style={{ cursor: "pointer" }}
              >
                <b>Duration</b>
                <svg
                  width="10"
                  height="8"
                  viewBox="0 0 13 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    transition: "transform 0.5s",
                    transform: !mobileIsOpenDuration
                      ? "rotate(0deg)"
                      : "rotate(180deg)",
                  }}
                >
                  <path
                    d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                    stroke="#222222"
                    strokeWidth="1.5"
                  />
                </svg>
              </h6>
              {mobileIsOpenDuration && (
                <div>
                  <div className="flex pt_10 align_items_center flex_gap_5">
                    <input
                      type="checkbox"
                      checked={durationArray.includes("3-4")}
                      onChange={() => handleDurationCheckboxChange("3-4")}
                      id="3-4"
                    />
                    <label htmlFor="3-4">4D/3N</label>
                  </div>
                  {/* <div className="flex pt_10 align_items_center flex_gap_5">
                  <input
                    type="checkbox"
                    checked={durationArray.includes("4-5")}
                    onChange={() => handleDurationCheckboxChange("4-5")}
                    id="4-5"
                  />
                  <label htmlFor="4-5">5D/4N</label>
                </div> */}
                  <div className="flex pt_10 align_items_center flex_gap_5">
                    <input
                      type="checkbox"
                      checked={durationArray.includes("5-6")}
                      onChange={() => handleDurationCheckboxChange("5-6")}
                      id="5-6"
                    />
                    <label htmlFor="5-6">6D/5N</label>
                  </div>
                  <div className="flex pt_10 align_items_center flex_gap_5">
                    <input
                      type="checkbox"
                      checked={durationArray.includes("6-7")}
                      onChange={() => handleDurationCheckboxChange("6-7")}
                      id="6-7"
                    />
                    <label htmlFor="6-7">7D/6N</label>
                  </div>
                  <div className="flex pt_10 align_items_center flex_gap_5">
                    <input
                      type="checkbox"
                      checked={durationArray.includes("8-9")}
                      onChange={() => handleDurationCheckboxChange("8-9")}
                      id="8-9"
                    />
                    <label htmlFor="8-9">9D/8N</label>
                  </div>
                  <div className="flex pt_10 align_items_center flex_gap_5">
                    <input
                      type="checkbox"
                      checked={durationArray.includes("9-10")}
                      onChange={() => handleDurationCheckboxChange("9-10")}
                      id="9-10"
                    />
                    <label htmlFor="9-10">10D/9N</label>
                  </div>
                  {/* <div className="load_more">Load More</div> */}
                </div>
              )}
            </div>

            <div className="filter_checkbox border-bottom-one">
              <h6
                className="flex_align_center justify_content_between"
                // onClick={toggleTheme}
                onClick={() => setMobileIsOpenTheme(!mobileIsOpenTheme)}
                style={{ cursor: "pointer" }}
              >
                <b>Themes</b>
                <svg
                  width="10"
                  height="8"
                  viewBox="0 0 13 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    transition: "transform 0.5s",
                    transform: !mobileIsOpenTheme
                      ? "rotate(0deg)"
                      : "rotate(180deg)",
                  }}
                >
                  <path
                    d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                    stroke="#222222"
                    strokeWidth="1.5"
                  />
                </svg>
              </h6>
              {mobileIsOpenTheme && (
                <div>
                  {themesArray?.slice().map((theme, i) => {
                    return (
                      <div key={i} className="flex pt_10 flex_gap_5">
                        <input
                          type="checkbox"
                          checked={selectedThemesArray.includes(theme?.handle)}
                          onChange={() =>
                            handleThemesHandleChange(theme?.handle)
                          }
                          id={theme.handle}
                        />
                        <label htmlFor={theme.handle}>{theme?.title}</label>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Destinations Filter */}
            {showDestinations && (
              <div className="filter_checkbox ">
                <h6
                  className="flex_align_center justify_content_between"
                  onClick={toggleAccordionDestination}
                  style={{ cursor: "pointer" }}
                >
                  <b>Destinations</b>
                  <svg
                    width="10"
                    height="8"
                    viewBox="0 0 13 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transition: "transform 0.5s",
                      transform: !isOpenDestination
                        ? "rotate(0deg)"
                        : "rotate(180deg)",
                    }}
                  >
                    <path
                      d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                      stroke="#222222"
                      strokeWidth="1.5"
                    />
                  </svg>
                </h6>
                {isOpenDestination && (
                  <>
                    <div>
                      <div className="flex pt_10 flex_gap_5 align_items_center">
                        <input
                          type="checkbox"
                          checked={destinationArray.includes("shimla")}
                          onChange={() =>
                            handleDestinationHandleChange("shimla")
                          }
                          id="shimla"
                        />
                        <label htmlFor="shimla"> Shimla</label>
                      </div>
                      <div className="flex pt_10 flex_gap_5 align_items_center">
                        <input
                          type="checkbox"
                          checked={destinationArray.includes("manali")}
                          onChange={() =>
                            handleDestinationHandleChange("manali")
                          }
                          id="manali"
                        />
                        <label htmlFor="manali"> Manali</label>
                      </div>
                      <div className="flex pt_10 flex_gap_5 align_items_center">
                        <input
                          type="checkbox"
                          checked={destinationArray.includes("dharamshala")}
                          onChange={() =>
                            handleDestinationHandleChange("dharamshala")
                          }
                          id="dharamshala"
                        />
                        <label htmlFor="dharamshala"> Dharamshala</label>
                      </div>
                      <div className="flex pt_10 flex_gap_5 align_items_center">
                        <input
                          type="checkbox"
                          checked={destinationArray.includes("dalhousie")}
                          onChange={() =>
                            handleDestinationHandleChange("dalhousie")
                          }
                          id="dalhousie"
                        />
                        <label htmlFor="dalhousie"> Dalhousie</label>
                      </div>
                      {/* <a href="">Load More</a> */}
                    </div>
                  </>
                )}
              </div>
            )}

            <div className="apply_btn">
              <button
                onClick={() => {
                  sendDataToParent(sendingData);
                  setModiyPkg(false);
                }}
                style={{ backgroundColor: "#016937" }}
                className="primary_btn"
              >
                <h4>Apply Now</h4>
              </button>
            </div>
          </div>
        )}
      </div>

      <div className={styles.filters_wrapper}>
        <div ref={overlayRef} className={styles.filters}>
          {/* Duration Filter */}
          <div  className={styles.filter_div} id="overlay">
            <div
              className={styles.filter_heading_parent}
              onClick={toggleAccordionDuration}
            >
              <div className={styles.filter_heading}>Duration</div>
              <svg
                width="10"
                height="8"
                viewBox="0 0 13 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  transition: "transform 0.5s",
                  transform: !isOpenDuration
                    ? "rotate(0deg)"
                    : "rotate(180deg)",
                }}
              >
                <path
                  d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                  stroke="#222222"
                  strokeWidth="1.5"
                />
              </svg>
            </div>
            {isOpenDuration && (
              <div className={styles.filter_content}>
                <div
                  className={styles.clear_all}
                  onClick={() => setDurationArray([])}
                >
                  Clear All
                </div>
                <div className="flex pt_10 align_items_center flex_gap_5">
                  <input
                    type="checkbox"
                    checked={durationArray.includes("3-4")}
                    onChange={() => handleDurationCheckboxChange("3-4")}
                    id="3-4"
                  />
                  <label htmlFor="3-4">4D/3N</label>
                </div>
                <div className="flex pt_10 align_items_center flex_gap_5">
                  <input
                    type="checkbox"
                    checked={durationArray.includes("5-6")}
                    onChange={() => handleDurationCheckboxChange("5-6")}
                    id="5-6"
                  />
                  <label htmlFor="5-6">6D/5N</label>
                </div>
                <div className="flex pt_10 align_items_center flex_gap_5">
                  <input
                    type="checkbox"
                    checked={durationArray.includes("6-7")}
                    onChange={() => handleDurationCheckboxChange("6-7")}
                    id="6-7"
                  />
                  <label htmlFor="6-7">7D/6N</label>
                </div>
                <div className="flex pt_10 align_items_center flex_gap_5">
                  <input
                    type="checkbox"
                    checked={durationArray.includes("8-9")}
                    onChange={() => handleDurationCheckboxChange("8-9")}
                    id="8-9"
                  />
                  <label htmlFor="8-9">9D/8N</label>
                </div>
                <div className="flex pt_10 align_items_center flex_gap_5">
                  <input
                    type="checkbox"
                    checked={durationArray.includes("9-10")}
                    onChange={() => handleDurationCheckboxChange("9-10")}
                    id="9-10"
                  />
                  <label htmlFor="9-10">10D/9N</label>
                </div>
                {/* <div className="load_more">Load More</div> */}
              </div>
            )}
          </div>

          {/* Destinations Filter */}
          {showDestinations && (
            <div className="filter_checkbox  border-bottom-one ">
              <h6
                className="flex_align_center justify_content_between"
                onClick={toggleAccordionDestination}
                style={{ cursor: "pointer" }}
              >
                <b>Destinations</b>
                <svg
                  width="10"
                  height="8"
                  viewBox="0 0 13 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    transition: "transform 0.5s",
                    transform: !isOpenDestination
                      ? "rotate(0deg)"
                      : "rotate(180deg)",
                  }}
                >
                  <path
                    d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                    stroke="#222222"
                    strokeWidth="1.5"
                  />
                </svg>
              </h6>
              {isOpenDestination && (
                <div>
                  <div className="flex pt_10 flex_gap_5">
                    <input
                      type="checkbox"
                      checked={destinationArray.includes("shimla")}
                      onChange={() => handleDestinationHandleChange("shimla")}
                      id="shimla"
                    />
                    <label htmlFor="shimla">Shimla</label>
                  </div>
                  <div className="flex pt_10 flex_gap_5">
                    <input
                      type="checkbox"
                      checked={destinationArray.includes("manali")}
                      onChange={() => handleDestinationHandleChange("manali")}
                      id="manali"
                    />
                    <label htmlFor="manali">Manali</label>
                  </div>
                  <div className="flex pt_10 flex_gap_5">
                    <input
                      type="checkbox"
                      checked={destinationArray.includes("dharamshala")}
                      onChange={() =>
                        handleDestinationHandleChange("dharamshala")
                      }
                      id="dharamshala"
                    />
                    <label htmlFor="dharamshala">Dharamshala</label>
                  </div>
                  <div className="flex pt_10 flex_gap_5">
                    <input
                      type="checkbox"
                      checked={destinationArray.includes("dalhousie")}
                      onChange={() =>
                        handleDestinationHandleChange("dalhousie")
                      }
                      id="dalhousie"
                    />
                    <label htmlFor="dalhousie">Dalhousie</label>
                  </div>
                  {/* <a href="">Load More</a> */}
                </div>
              )}
            </div>
          )}

          {/* themes Filter */}
          {/* {showDestinations && ( */}
          <div className={styles.filter_div}>
            <div className={styles.filter_heading_parent} onClick={toggleTheme}>
              <div className={styles.filter_heading}>Themes</div>

              <svg
                width="10"
                height="8"
                viewBox="0 0 13 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  transition: "transform 0.5s",
                  transform: !themeOpen ? "rotate(0deg)" : "rotate(180deg)",
                }}
              >
                <path
                  d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                  stroke="#222222"
                  strokeWidth="1.5"
                />
              </svg>
            </div>
            {themeOpen && (
              <div className={styles.filter_content}>
                <div
                  className={styles.clear_all}
                  onClick={() => setSelectedThemesArray([])}
                >
                  Clear All
                </div>
                {themesArray?.slice().map((theme, i) => {
                  return (
                    <div
                      key={i}
                      className="flex pt_10 align_items_center flex_gap_5"
                    >
                      <input
                        type="checkbox"
                        checked={selectedThemesArray.includes(theme?.handle)}
                        onChange={() => handleThemesHandleChange(theme?.handle)}
                        id={theme.handle}
                      />
                      <label htmlFor={theme.handle}>{theme?.title}</label>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          {/* )} */}
        </div>
      </div>
    </>
  );
}
export default NewFilterHoliday;
